/**
 * The community board (`D276`): route functions, the key and the mutations.
 * Online only, never the outbox (`D163`); a post carries the client's
 * UUIDv7, minted once per form, and a vote is a PUT/DELETE on its pair.
 */
import { boardOutput, COMMUNITY_BOARD_ROUTES, communityPostOutput, communityPostVoteOutput, communityPostVotePath, } from "@repo/contract/community";
import { getJson, sendJson, } from "../core/request";
export const boardKeys = {
    board: () => ["community", "board"],
};
/** `GET /me/community/posts` — the board and the caller's own posts. */
export function fetchBoard(api, init) {
    return getJson(api, COMMUNITY_BOARD_ROUTES.posts, boardOutput, init);
}
export function boardOptions(api) {
    return {
        queryFn: ({ signal }) => fetchBoard(api, { signal }),
        queryKey: boardKeys.board(),
        staleTime: 5 * 60_000,
    };
}
export function communityPostMutation(api) {
    return {
        invalidates: [boardKeys.board()],
        mutationFn: (input) => sendJson(api, "POST", COMMUNITY_BOARD_ROUTES.posts, input, communityPostOutput),
        mutationKey: ["community", "post"],
    };
}
export function communityPostVoteMutation(api) {
    return {
        invalidates: [boardKeys.board()],
        mutationFn: (input) => sendJson(api, input.voted ? "PUT" : "DELETE", communityPostVotePath(input.postId), undefined, communityPostVoteOutput),
        mutationKey: ["community", "post-vote"],
    };
}
//# sourceMappingURL=board.js.map